import { useState } from "react";

import { AddMoreButton, SectionTitle } from "@components";
import { UploadDocument } from "./UploadDocument";
import { NewUploadDocument } from "./NewUploadDocument";

import { AttachedFilesType } from "@type/HRM/attached-files";
import { UploadFileType } from "@type/HRM/upload-file";

interface UploadDocumentPropsType {
  attachedFiles: AttachedFilesType;
  createAttachedFile: (uploadedFile: UploadFileType) => void;
  removeAttachedFile: (uploadFile: UploadFileType) => void;
  getAttachedFileRequestOngoing: boolean;
  updateAttachedFileRequestOngoing: boolean;
  deleteAttachedFileRequestOngoing: boolean;
  isProfileDisabled: boolean;
}

export const UploadDocuments = ({
  attachedFiles,
  createAttachedFile,
  removeAttachedFile,
  getAttachedFileRequestOngoing,
  updateAttachedFileRequestOngoing,
  deleteAttachedFileRequestOngoing,
  isProfileDisabled,
}: UploadDocumentPropsType) => {
  const [newUploadDocumentFormShow, setNewUploadDocumentFormShow] =
    useState(false);
  const handleNewUploadDocumentFormShow = (isShow: boolean) =>
    setNewUploadDocumentFormShow(isShow);

  return (
    <div className="d-flex flex-column gap-8 mb-10">
      <SectionTitle
        label="EMPLOYEE.ATTACHED_FILES.FORM.UPLOAD_DOC.HEADING"
        size="lg"
        noBorder
      />

      {attachedFiles?.attachmentDocument?.map((doc: any, index: number) => (
        <UploadDocument
          key={index}
          attachedFile={doc}
          createAttachedFile={createAttachedFile}
          removeAttachedFile={removeAttachedFile}
          getAttachedFileRequestOngoing={getAttachedFileRequestOngoing}
          updateAttachedFileRequestOngoing={updateAttachedFileRequestOngoing}
          deleteAttachedFileRequestOngoing={deleteAttachedFileRequestOngoing}
          isProfileDisabled={isProfileDisabled}
        />
      ))}

      {newUploadDocumentFormShow ? (
        <NewUploadDocument
          handleNewUploadDocumentFormShow={handleNewUploadDocumentFormShow}
          createAttachedFile={createAttachedFile}
          updateAttachedFileRequestOngoing={updateAttachedFileRequestOngoing}
          isProfileDisabled={isProfileDisabled}
        />
      ) : (
        <AddMoreButton
          label="EMPLOYEE.ATTACHED_FILES.FORM.ADD_MORE_BUTTON"
          clickAction={() => handleNewUploadDocumentFormShow(true)}
          disabled={isProfileDisabled}
        />
      )}
    </div>
  );
};

export default UploadDocuments;
